import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "../../components/motion";
import { SectionLabel } from "../../components/SectionLabel";
import { BentoTile } from "../../components/BentoTile";
import { asList, useFetch } from "../../lib/api";

const SPANS = [
  "h-[420px] md:col-span-2 lg:col-span-2 lg:row-span-2 lg:h-auto",
  "h-[320px] md:col-span-2 lg:col-span-2 lg:h-auto",
  "h-[320px] lg:h-auto",
  "h-[320px] lg:h-auto",
];

export const ProductsBento = () => {
  const { data } = useFetch("/products");
  const items = asList(data).slice(0, 4);
  if (!items.length) return null;
  return (
    <section data-testid="home-products" className="bg-paper py-24 sm:py-32">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <SectionLabel index="03" className="text-moss">Product pipeline</SectionLabel>
            <MaskLines lines={["What's available,", "what's coming next."]} className="mt-8 font-display text-4xl font-normal leading-[1.02] tracking-[-0.02em] text-teal sm:text-5xl lg:text-6xl" />
          </div>
          <Link to="/products" data-testid="home-products-viewall" className="group label-caps inline-flex items-center gap-3 self-start text-teal lg:self-auto">
            <span className="link-underline pb-1">All products</span>
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </div>
        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[300px_300px]">
          {items.map((p, i) => (
            <BentoTile key={p.id} product={p} index={i} large={i === 0} className={SPANS[i]} />
          ))}
        </div>
      </div>
    </section>
  );
};
